import React from 'react';
import { useFormContext } from 'react-hook-form';

import * as styled from './styles';

type Props = {
  name: string;
  label: React.ReactNode;
  disabled?: boolean;
};

export const FormCheckbox = ({ name, label, disabled }: Props) => {
  const {
    register,
    formState: { errors },
  } = useFormContext();
  const error = errors[name]?.message as string | undefined;

  return (
    <styled.Field>
      <styled.CheckRow>
        <input type="checkbox" {...register(name)} disabled={disabled} />
        <styled.CheckLabel>{label}</styled.CheckLabel>
      </styled.CheckRow>
      {error && <styled.ErrorText>{error}</styled.ErrorText>}
    </styled.Field>
  );
};
